export const SUPPORT_EMAIL = 'uk_equityrewardanalytics_support@pwc.com';
